import { render, staticRenderFns } from "./ChatPreload.vue?vue&type=template&id=72bf3274&scoped=true&"
import script from "./ChatPreload.vue?vue&type=script&lang=js&"
export * from "./ChatPreload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf3274",
  null
  
)

export default component.exports